import { ISurvey } from "./index";

export enum SurveyAction {
    SurveyConfirm,
    SurveyConfirmError
}

export interface ISurveyAction {
    type: SurveyAction;
    payload: Partial<ISurvey>;
}